// extracted by mini-css-extract-plugin
export default {"btn-xs":"Search_btn-xs__IR-ZQ","hitsList":"Search_hitsList__cw4Sx","hitsItem":"Search_hitsItem__SFy7w","refinementLabel":"Search_refinementLabel__MObuS"};